export default __webpack_public_path__ + "static/media/bank-icon.9b47281f.svg";